// init fe-group-logic-validation
import FeGroupLogicValidation from "../components/backend/fe-group-logic-validation.ts";

document.addEventListener('DOMContentLoaded', () => {
    console.log('DOMContentLoaded ausgelöst');
    FeGroupLogicValidation.initialize();
});
